$(function () {
  var handle = function () {
    var container = $(this).parents('fieldset').first();
    var filename = this.files[0].name;
    container.find('label').html(filename).toggleClass('file-selected',true);
  }

  $(document).on('ajaxComplete',function () {
    $('#contact-form-uploadSection input').off('change',handle).on('change',handle)
  })
})
